import { useEffect, useState } from "react";
import { useCart } from "@/app/providers/CartProvider";
import { ordersApi } from "../api/ordersApi";

/**
 * Проверяет статус заказа из черновика.
 * Баннер «не оплачен» — только если на сервере ещё pending
 * (GET order синхронизирует статус с ЮKassa, если webhook не пришёл).
 */
export function usePendingOrderSync(): { showUnpaidReminder: boolean } {
  const { hasPendingOrderDraft, clearPendingOrderDraft, pendingOrderDraft } =
    useCart();

  const orderId = pendingOrderDraft?.orderId;
  const [showUnpaidReminder, setShowUnpaidReminder] = useState(false);

  useEffect(() => {
    if (!hasPendingOrderDraft || !orderId) {
      queueMicrotask(() => setShowUnpaidReminder(false));
      return;
    }

    let cancelled = false;

    const tick = async () => {
      try {
        const order = await ordersApi.getOrderById(orderId);
        if (cancelled) return;

        if (!order) {
          setShowUnpaidReminder(true);
          return;
        }
        if (order.status === "completed" || order.status === "cancelled") {
          clearPendingOrderDraft();
          setShowUnpaidReminder(false);
        } else {
          setShowUnpaidReminder(true);
        }
      } catch {
        if (!cancelled) {
          setShowUnpaidReminder(true);
        }
      }
    };

    queueMicrotask(() => setShowUnpaidReminder(false));

    void tick();
    const interval = window.setInterval(() => void tick(), 60_000);
    const onVis = () => {
      if (document.visibilityState === "visible") void tick();
    };
    document.addEventListener("visibilitychange", onVis);

    return () => {
      cancelled = true;
      window.clearInterval(interval);
      document.removeEventListener("visibilitychange", onVis);
    };
  }, [hasPendingOrderDraft, orderId, clearPendingOrderDraft]);

  return { showUnpaidReminder };
}
